/**
 * Lecture des retours de redirection Azure AD B2C (voir b2cRedirect.test.ts).
 *
 * Le flux « Connexion » ne réinitialise pas le mot de passe lui-même : son lien
 * « Vous avez oublié votre mot de passe ? » renvoie à l'application l'erreur
 * AADB2C90118, et c'est à elle d'ouvrir le flux « Réinitialisation du mot de
 * passe » (`b2cPolicyConfig.authorities.forgotPassword`). Sans ce relais,
 * l'utilisateur revenait en silence sur la page d'accueil (constaté le
 * 23 septembre 2026).
 */

function messageOf(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const e = error as { errorMessage?: unknown; message?: unknown };
    if (typeof e.errorMessage === 'string') return e.errorMessage;
    if (typeof e.message === 'string') return e.message;
  }
  return '';
}

/** Retour du lien « Vous avez oublié votre mot de passe ? » (AADB2C90118). */
export function isForgotPasswordError(error: unknown): boolean {
  return messageOf(error).includes('AADB2C90118');
}

/** Réinitialisation abandonnée par l'utilisateur (AADB2C90091). */
export function isCancelledByUser(error: unknown): boolean {
  return messageOf(error).includes('AADB2C90091');
}

/** Le jeton reçu vient-il du flux de réinitialisation (réclamation `tfp` ou `acr`) ? */
export function isPasswordResetResponse(claims: Record<string, unknown> | undefined, resetPolicy: string): boolean {
  if (!claims || !resetPolicy) return false;
  const policy = String(claims.tfp ?? claims.acr ?? '');
  return policy.toLowerCase() === resetPolicy.toLowerCase();
}
